module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG4AAAAFCAYAAACkaNliAAAAAXNSR0IArs4c6QAAATlJREFUSEvtlFFuwjAQRCcfIPV6UGi5/yWgLVCN5IdGK8chn0hEsrweb+xkn8eT3s9LVmCS9C3pIOmvtV9JF0nurTH+abF7ctGcc5WUcx67MefY76HfWuyedm+xc9BcWHRrxO79WMuefPI89n/yboJijSVtad7reA/2prfGXG+vzK8HaC7feRsvfJL02YqYoABnGNnQnYue0BMUsABGX6E5L+EwtkZLuAkzf5DcCgodiAm3Fi/X6xWeg1JBVWg9J48OSp0bgf7w5kdJu3AXQOw6HGXtHOOEmu4EPPAqsATnON2GI3BbOqsCTIc988NrTnu6Z8lp1Vlrrt2Ro0ZOfDjuS9K+XHXAyKuwaj3HAQ4H5tVYr0nApdPyKiROaHn9VZ2iUZClwtT8LHrPTXNQeg5dA3D0HXOu3f4DyivtJ1eytl0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/pic3.png
// module id = 956O
// module chunks = 1